import { UserRoles } from '../../../components/roster/types';

export type LoadingStates = 'INITIAL' | 'LOADING' | 'SUCCESS' | 'PARTIAL-SUCCESS' | 'ERROR';

export type InviteTabTypes = 'simple' | 'advanced' | 'bulkImport' | 'msTeams' | 'error';

// string values used for translation key matching
export enum InviteTabs {
    SIMPLE = 'simple',
    ADVANCED = 'advanced',
    BULK_IMPORT = 'bulkImport',
    MS_TEAMS = 'msTeams',
    ERROR = 'error'
}

export interface Student {
    firstName: string;
    lastName: string;
    email: string;
    role?: UserRoles;
}

export interface InviteStudentsAlert {
    category: 'validationError' | 'uploadError' | 'uploadSuccess'; // for programatically removing alerts
    message: string | any;
    severity: 'error' | 'success';
    onClose?: () => void;
}

export interface InviteStudentsResponse {
    status: number;
    body: InviteStudentsResponseBody | InviteErrorBody;
}

export interface InviteStudentsResponseBody {
    success: boolean;
    failedEnrollments?: Record<string, string>[];
    failedEmailSends?: Record<string, string>[];
}

export interface InviteErrorBody {
    error: string;
    errorCode?: string;
    errorData?: any;
    data?: any;
}
